/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { ServerErrorSVG } from '../../img/GlobalSVG';

export default function WorkInProgress() {
  return (
    <>
      <Container fluid className="claims-details">
        <Row className="ml-1 d-none d-md-block d-lg-block ">
          <h1 id="greetings-time">Branding</h1>
        </Row>
        <Row>
          <Col className="col-12">
            <div className="coming-soon1">
              {/*<img src={require('../../img/comingsoon.svg')} alt="Coming Soon"/> */}
              <ServerErrorSVG.WorkInprogressSVG />
              <h3>Work in progress</h3>

              <p>
                This feature will be added very soon to our member portal.
                Meanwhile, you can continue using other features here.
              </p>
              <Link to="/admin/admin-dashboard">
                {' '}
                <Button className="register" block>
                  GO TO DASHBOARD
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
